import { useFormContext } from "react-hook-form";
import {
  ACTIVE_STATUS,
  STATUS,
} from "@circle-react/helpers/communityMemberSubscriptionHelpers";
import { useAdminPaywallSubscription } from "@circle-react/hooks/paywalls/useAdminPaywallSubscription";
import { TABS, TABS_LOCALE, type TabType } from "../constants";

interface TabOption {
  badge: { value: number };
  label: string;
  value: TabType;
}

interface UseTabWithFiltersReturn {
  changeTabAndResetSearchForm: (tab: TabType) => void;
  tabOptions: TabOption[];
}

// Extended filters interface to include status for subscriptions
interface SubscriptionFilters {
  community_member_id?: string;
  community_member_public_uid?: string;
  paywall_ids?: string;
  processor_id?: string;
  status?: string;
}

export const useTabWithFilters = (
  setActiveFilterTab: (tab: TabType) => void,
  setSearchKey: (key: string) => void,
  resetAllSubscriptionToFirstPage: () => void,
): UseTabWithFiltersReturn => {
  // Using dummy page state since we only need counts
  const dummySetPage = () => {};

  const allSubscriptions = useAdminPaywallSubscription({
    perPage: 1,
    page: 1,
    setPage: dummySetPage,
  });
  const activeSubscriptions = useAdminPaywallSubscription({
    filters: { status: ACTIVE_STATUS.join(",") } as SubscriptionFilters,
    perPage: 1,
    page: 1,
    setPage: dummySetPage,
  });
  const canceledSubscriptions = useAdminPaywallSubscription({
    filters: { status: STATUS.CANCELED } as SubscriptionFilters,
    perPage: 1,
    page: 1,
    setPage: dummySetPage,
  });

  const tabOptions: TabOption[] = [
    [TABS.ALL, allSubscriptions] as const,
    [TABS.ACTIVE, activeSubscriptions] as const,
    [TABS.CANCELED, canceledSubscriptions] as const,
  ].map(([tab, subscriptionsData]) => ({
    value: tab,
    label: TABS_LOCALE[tab],
    badge: { value: subscriptionsData.totalSubscriptions },
  }));

  const { reset } = useFormContext();
  const changeTabAndResetSearchForm = (tab: TabType): void => {
    reset({ searchKey: "" });
    setSearchKey("");

    resetAllSubscriptionToFirstPage();

    setActiveFilterTab(tab);
  };

  return {
    tabOptions,
    changeTabAndResetSearchForm,
  };
};
